
import request from '../../api/agent';
import {
 
    GET_PAYER_DROPDOWN,
    GET_CLIENTS_DROPDOWN_LISTS_URL,
    GET837RESETCLAIMWISENEWGRID

} from './../../api/commonRoutepath';

// client 


export const getAllClientDropdown = ({ isAutomation = false } = {}) => onResponse => {
    try {
        request.get(GET_CLIENTS_DROPDOWN_LISTS_URL+ "?is_automation=" + isAutomation )
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getPayerDropdown = () => onResponse => {
    try {
        request.get(GET_PAYER_DROPDOWN)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAutomationReset837ClaimNewGrid = async (data) => {
    try {
        const response = await request.post(GET837RESETCLAIMWISENEWGRID, data);
        return response.data;  // Return the data directly
    } catch (error) {
        console.error("Error in getAutomationReset837Claim:", error);
        throw error; // Properly propagate the error
    }
    
};